// Phone toolbar: below 600px the less-used buttons (bookmark, extensions, collapse, account)
// fold into a "More" tray so the address bar and Settings always fit. On wider screens the
// tray is display:contents and this does nothing visible.
const $ = (id) => document.getElementById(id);

export function initNavMore() {
	const btn = $("rv-more"), tray = $("rv-nav-more");
	if (!btn || !tray) return;
	const isOpen = () => tray.hasAttribute("data-open");
	const close = () => {
		if (!isOpen()) return;
		tray.removeAttribute("data-open");
		btn.setAttribute("aria-expanded", "false");
	};
	const open = () => {
		const r = btn.getBoundingClientRect();
		tray.style.top = Math.round(r.bottom + 6) + "px";
		tray.setAttribute("data-open", "");
		btn.setAttribute("aria-expanded", "true");
		const first = tray.querySelector("button:not([hidden]):not([disabled])");
		if (first) first.focus();
	};
	btn.addEventListener("click", () => (isOpen() ? close() : open()));
	// stays open while the extensions panel it opened is in use
	document.addEventListener("pointerdown", (e) => {
		if (!isOpen() || tray.contains(e.target) || btn.contains(e.target) || e.target.closest(".rv-extp")) return;
		close();
	}, true);
	document.addEventListener("keydown", (e) => {
		if (e.key === "Escape" && isOpen()) { close(); btn.focus(); }
	});
	// tabbing out of the tray closes it, so it never sits open over the page behind the focus
	tray.addEventListener("focusout", (e) => {
		const to = e.relatedTarget;
		if (!to || tray.contains(to) || btn.contains(to) || (to.closest && to.closest(".rv-extp"))) return;
		close();
	});
	// bookmark, collapse and account do their thing and the tray goes away
	tray.addEventListener("click", (e) => {
		const b = e.target.closest("button");
		if (b && b.id !== "rv-ext") close();
	});
	matchMedia("(min-width: 600px)").addEventListener("change", close);
	// incognito lives in the tray on phones, so the More button carries its dot
	const inc = $("rv-incognito");
	if (inc) {
		const sync = () => {
			btn.classList.toggle("rv-more-dot", !inc.hidden);
			btn.setAttribute("aria-label", inc.hidden ? "More toolbar buttons" : "More toolbar buttons (incognito is on)");
		};
		new MutationObserver(sync).observe(inc, { attributes: true, attributeFilter: ["hidden"] });
		sync();
	}
}
